// src/app/pages/admin/exam_loc/rtAdExamLoc.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamLoc = Loadable(lazy(() => import("./ExamLoc")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/exam-loc`,
  element: <ExamLoc />
}));

export default routes;